var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.dataSource,"height":"notset"}})
}
var staticRenderFns = []

export { render, staticRenderFns }